import '../style.css'
import StepOneIcon from "src/components/logos/StepOneIcon.png";
import { Typography, Stack, Button, Divider, alpha } from "@mui/material";
import Check from "src/components/logos/Check.png";

export const TimelineStepFive = (props) => {
  const { onNext,onBack } = props;

    return (
        <Stack 
            spacing={3} 
            direction="column" 
            className='contentBorder' 
            sx={{
                backgroundColor: theme => alpha(theme.palette.primary.main, 0.1),
                border: theme => `1px solid ${alpha(theme.palette.primary.main, 0.1)}`
            }}
        >
            <>
                <Stack direction='row' spacing={1}>
                    <img src={StepOneIcon} />
                    <Typography variant="h6" sx={{ color: '#050C46',fontSize:'16px',fontWeight:'700' }}>Now</Typography>
                </Stack>
                <Stack direction="row" spacing={1} sx={{padding:'0px 28px'}}>
                    <img src={Check} height="20px" />
                    <Typography sx={{ fontSize: '14px', fontWeight: 500, color: '#050C46' }}>send the Prospect Email Reply email to the user</Typography>
                </Stack>
            </>
            
            <Stack direction="row" spacing={1}>
            <Button 
            fullWidth
            size='small'
            className='BackButton'
            onClick={onBack}
            variant='outlined'
            >Back</Button>

            <Button fullWidth className='currentButton' onClick={onNext}>Current Stage</Button>

            </Stack>        

        </Stack>
    );
};